import _isEmpty from 'lodash/isEmpty';
import Page from './page';
import { setPuiTopicEnabled } from '../contactUs/actions/action-login-modal';
import { getQueryValue } from './location-helper';
import { logoutEmailQuery } from './emailUtil';

// this file tests additional locale and intents from rc pui_webform_config to show email us without
// loggedin link in login prompt when users clicks email us

// get rc config from window which infact get config from rc pui_webform_config
export const getPuiTopicConfig = () => {
  try {
    if (window && window.puiTopicConfig) {
      return window.puiTopicConfig;
    }
    return {};
  } catch (e) {
    return {};
  }
};

/**
 * Function to check country/locale in the remote config
 */
export const isPuiTopicLocaleEnabledInRc = (puiTopicConfig) => {
  if (!_isEmpty(puiTopicConfig) && puiTopicConfig.enabledLocales) {
    const country = (Page.getCountry()).toUpperCase();
    const locale = Page.getAPILocalilty();

    return puiTopicConfig.enabledLocales.split(',')
      .filter((market) => market.indexOf(`${country}:`) >= 0)
      .filter((selectedMarket) => selectedMarket.split(':')[1].indexOf(locale) >= 0)
      .length > 0;
  }

  return false;
};

/**
 * Function to check intents in the remote config
 */
export const isPuiTopicEnabledIntent = (intentId, puiTopicConfig) => {
  if (!_isEmpty(puiTopicConfig) && !_isEmpty(puiTopicConfig.enabledIntents)) {
    if (intentId) {
      const intents = Object.values(puiTopicConfig.enabledIntents);
      // Checking for existance of topic refid in RC
      return (Array.isArray(intents) && intents.length > 0 && intents.indexOf(intentId) >= 0);
    }
    // getting the email query value from url
    // if topicrefid not available checking for topic existance in RC (payuponinvoice from url)
    const queryValue = getQueryValue(logoutEmailQuery, window.location);
    return puiTopicConfig.enabledIntents[queryValue];
  }
  return false;
};

/**
 * Function to check intents and country/locale in the remote config
 */
export const isPUIIntentEnabled = (topicRefId = '') => {
  const puiTopicConfig = getPuiTopicConfig();
  return isPuiTopicEnabledIntent(topicRefId, puiTopicConfig) && isPuiTopicLocaleEnabledInRc(puiTopicConfig);
};

// action creator that goes to reducer-login-modal to change status of puiTopicEnabled
export const requestPuiTopicValidation = (topicRefId) => (dispatch) => dispatch(setPuiTopicEnabled(isPUIIntentEnabled(topicRefId)));

/**
 * Function to return tcode from the remote config based on the email value in the url
 */
export const returnTcodeWithEmailQuery = () => {
  // getting the email query value from url
  const queryValue = getQueryValue(logoutEmailQuery, window.location);
  if (isPUIIntentEnabled()) {
    const puiTopicConfig = getPuiTopicConfig();
    return puiTopicConfig.enabledIntents[queryValue];
  }
  return '';
};
